import React, { useEffect, useState, useRef, createRef } from "react";
import {
  EuiFlexGroup,
  EuiText,
  EuiFlexItem,
  EuiButton,
  EuiCheckbox,
  EuiForm,
  EuiTextColor,
  EuiButtonIcon,
} from "@elastic/eui";
import { submitSubscription } from "../../api/subscription/submitSubscription";
import { fetchSubscriptionConfigurations } from "../../api/subscription/fetchSubscriptionConfigurations";
import { fetchPlans } from "../../api/subscription/fetchPlans";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import NumberField from "../Form/NumberField";
import { isEmpty } from "lodash";

const RestaurantSubscription = (props) => {
  const { selectedRestaurant } = props;
  const dispatch = useDispatch();
  // Outlet selection removed as per requirement
  // const [isModalVisible, setIsModalVisible] = useState(false);
  const [url, setUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [showError, setShowError] = useState(false);
  const [existingConfigurations, setExistingConfigurations] = useState([]);
  const [plans, setPlans] = useState([]);
  const [planFieldMapping, setPlanFieldMapping] = useState({});

  const inputRefs = useRef({});

  const onWheel = () => {
    Object.values(inputRefs.current).forEach((ref) => {
      if (ref && ref.current) {
        ref.current.blur();
      }
    });
  };

  // Helper function to extract days from plan name
  const extractDaysFromPlan = (planName) => {
    const match = planName.match(/(\d+)\s*days/);
    return match ? parseInt(match[1]) : null;
  };

  // Helper function to convert plan name to field name
  const planToFieldName = (planName) => {
    if (planName.toLowerCase().includes("monthly")) return "monthly";
    if (planName.toLowerCase().includes("quarterly")) return "quaterly";
    if (planName.toLowerCase().includes("half yearly")) return "half_yearly";
    if (
      planName.toLowerCase().includes("yearly") &&
      !planName.toLowerCase().includes("half")
    )
      return "yearly";
    // Default mapping based on days
    const days = extractDaysFromPlan(planName);
    if (days === 28) return "monthly";
    if (days === 90) return "quaterly";
    if (days === 180) return "half_yearly";
    if (days === 365) return "yearly";
    return null;
  };

  const { handleSubmit, errors, control, watch, reset, setValue } = useForm({
    defaultValues: {
      monthly: false,
      quaterly: false,
      half_yearly: false,
      yearly: false,
      monthly_charges: "",
      quaterly_charges: "",
      half_yearly_charges: "",
      yearly_charges: "",
    },
  });

  const [checkboxIdToSelectedMap, setCheckboxIdToSelectedMap] = useState({});

  // Fetch plans when restaurant is selected
  useEffect(() => {
    if (selectedRestaurant && selectedRestaurant[0]) {
      dispatch(fetchPlans(selectedRestaurant[0].id)).then((res) => {
        if (res && res.success && res.plans) {
          // The API returns `plans` as a keyed map, e.g.
          // { "28": "Monthly (28 days)", "90": "Quarterly (90 days)", ... }
          // The helpers below parse the label, so take the values.
          const planList = Array.isArray(res.plans)
            ? res.plans
            : Object.values(res.plans);

          setPlans(planList);
          // Create mapping for plans
          const mapping = {};
          planList.forEach((plan, index) => {
            const fieldName = planToFieldName(plan);
            if (fieldName) {
              mapping[index] = {
                fieldName,
                planName: plan,
                days: extractDaysFromPlan(plan),
              };
              // Initialize ref for this field
              if (!inputRefs.current[fieldName]) {
                inputRefs.current[fieldName] = createRef();
              }
            }
          });
          setPlanFieldMapping(mapping);
        }
      });
    }
  }, [selectedRestaurant, dispatch]);

  // Fetch existing subscription configurations when restaurant is selected
  useEffect(() => {
    if (selectedRestaurant && selectedRestaurant[0]) {
      dispatch(fetchSubscriptionConfigurations(selectedRestaurant[0].id)).then(
        (res) => {
          if (res.success && res.subscription_configurations) {
            setExistingConfigurations(res.subscription_configurations);

            // Create an object with all the form values
            const formValues = {
              monthly: false,
              quaterly: false,
              half_yearly: false,
              yearly: false,
              monthly_charges: "",
              quaterly_charges: "",
              half_yearly_charges: "",
              yearly_charges: "",
            };

            const configurations = res.subscription_configurations;
            console.log(`adfafasdfasdconfigurations ==>`, configurations);

            configurations.forEach((config) => {
              const duration = parseInt(config.duration);
              const amount = parseFloat(config.amount).toString();
              console.log(`adfafasdfasdamount ==>`, amount, duration);

              switch (duration) {
                case 28:
                  formValues.monthly = true;
                  formValues.monthly_charges = amount;
                  break;
                case 90:
                  formValues.quaterly = true;
                  formValues.quaterly_charges = amount;
                  break;
                case 180:
                  formValues.half_yearly = true;
                  formValues.half_yearly_charges = amount;
                  break;
                case 365:
                  formValues.yearly = true;
                  formValues.yearly_charges = amount;
                  break;
              }
            });

            // Reset the form with all values at once
            reset(formValues);
          } else {
            // Reset form if no configurations exist
            reset({
              monthly: false,
              quaterly: false,
              half_yearly: false,
              yearly: false,
              monthly_charges: "",
              quaterly_charges: "",
              half_yearly_charges: "",
              yearly_charges: "",
            });
            setExistingConfigurations([]);
          }
        },
      );
    }
  }, [selectedRestaurant, dispatch, reset]);

  // onChange function removed as outlet selection is no longer needed

  // const onDurationChange = (optionId) => {
  //   const newCheckboxIdToSelectedMap = {
  //     ...checkboxIdToSelectedMap,
  //     ...{
  //       [optionId]: !checkboxIdToSelectedMap[optionId],
  //     },
  //   };
  //   setCheckboxIdToSelectedMap(newCheckboxIdToSelectedMap);
  // };

  const onSubmit = (data) => {
    console.log(`data ==>`, data);
    let innerObj = {};
    let subscription_configurations = [];

    // Dynamically process plan configurations based on planFieldMapping
    Object.values(planFieldMapping).forEach(({ fieldName, days }) => {
      if (data[fieldName] && days) {
        subscription_configurations.push({
          duration: days.toString(),
          amount: data[`${fieldName}_charges`],
        });
      }
    });

    console.log(
      `adfafasdfasdfsubscription_configurations ==>`,
      subscription_configurations,
    );
    innerObj["subscription_configurations"] = subscription_configurations;
    dispatch(submitSubscription(selectedRestaurant[0].id, innerObj)).then(
      (res) => {
        if (res.success) {
          setUrl(res.subscription_configurations);
          // setIsModalVisible(true);
        } else {
          if (res.errors) {
            setErrorMessage(res.errors);
            setShowError(true);
          }
          alert("Fail to submit data");
        }
      },
    );
  };

  const closeModal = () => {
    // setIsModalVisible(false);
    // Outlet selection reset removed
    reset({
      monthly: undefined,
      quaterly: undefined,
      half_yearly: undefined,
      yearly: undefined,
    });
  };

  let modal;

  // if (isModalVisible) {
  //   modal = (
  //     <EuiModal onClose={closeModal} initialFocus="[name=popswitch]">
  //       <EuiModalHeader>
  //         <EuiModalHeaderTitle>
  //           <h1>Modal title</h1>
  //         </EuiModalHeaderTitle>
  //       </EuiModalHeader>

  //       <EuiModalBody>
  //         <TextField
  //           errors={errors}
  //           label="Sharable url"
  //           name="url"
  //           control={control}
  //           watch={watch}
  //           disabled={true}
  //           defaultValue={url}
  //           append={
  //             <EuiCopy textToCopy={url}>
  //               {(copy) => <EuiText onClick={copy}>Copy</EuiText>}
  //             </EuiCopy>
  //           }
  //         />
  //       </EuiModalBody>

  //       <EuiModalFooter>
  //         <EuiButton type="submit" form="modalFormId" onClick={closeModal} fill>
  //           Close
  //         </EuiButton>
  //       </EuiModalFooter>
  //     </EuiModal>
  //   );
  // }

  // display error from server side
  const displayErrorServer = () => {
    let errorsList = [];
    if (!isEmpty(errorMessage)) {
      for (var key in errorMessage) {
        errorsList.push(
          <EuiTextColor color="danger">{errorMessage[key]}</EuiTextColor>,
        );
      }
    }
    return errorsList;
  };

  return (
    <>
      {modal}
      <EuiForm component="form" onSubmit={handleSubmit(onSubmit)}>
        <EuiFlexItem>
          <div className="" style={{ margin: "10px" }}>
            {/* Dynamic subscription plans */}
            {plans.map((plan, index) => {
              const mapping = planFieldMapping[index];
              if (!mapping) return null;

              const { fieldName, planName } = mapping;
              const chargesFieldName = `${fieldName}_charges`;

              return (
                <EuiFlexGroup
                  key={index}
                  alignItems="center"
                  style={{ padding: "10px 0px" }}
                >
                  <EuiFlexItem grow={false}>
                    <Controller
                      render={({ onChange, value }) => (
                        <EuiCheckbox
                          onChange={(e) => {
                            onChange(e.target.checked);
                            setValue(fieldName, e.target.checked);
                          }}
                          checked={value}
                          compressed
                        />
                      )}
                      name={fieldName}
                      control={control}
                    />
                  </EuiFlexItem>
                  <EuiFlexItem grow={false}>
                    <EuiText>{planName}</EuiText>
                  </EuiFlexItem>

                  <EuiFlexItem grow={false}>
                    {watch(fieldName) ? (
                      <NumberField
                        errors={errors}
                        name={chargesFieldName}
                        placeholder={`${planName.split(" ")[0]} Charges`}
                        rules={{
                          required: `Please enter ${planName.toLowerCase()} charges`,
                        }}
                        control={control}
                        watch={watch}
                        inputRef={inputRefs.current[fieldName]}
                        onWheel={onWheel}
                      />
                    ) : (
                      ""
                    )}
                  </EuiFlexItem>
                </EuiFlexGroup>
              );
            })}
          </div>

          {!isEmpty(errorMessage) && showError && (
            <EuiFlexGroup
              direction="column"
              style={{
                backgroundColor: "#f8e9e9",
                margin: "10px",
                padding: "15px",
                borderRadius: "5px",
              }}
            >
              <EuiFlexItem
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <EuiTextColor color="danger" style={{ paddingBottom: "10px" }}>
                  <b>Please resolve below validations</b>
                </EuiTextColor>
                <EuiButtonIcon
                  color={"warning"}
                  onClick={() => setShowError(false)}
                  iconType="cross"
                  aria-label="cross"
                />
              </EuiFlexItem>
              {displayErrorServer()}
            </EuiFlexGroup>
          )}

          <EuiButton type="submit" fill style={{ width: "200px" }}>
            Submit
          </EuiButton>
        </EuiFlexItem>
      </EuiForm>
    </>
  );
};

export default RestaurantSubscription;
